module.exports = __webpack_public_path__ + "img/radio-box-on.0b004a10.svg";